const apiBaseUrl =
  process.env.REACT_APP_API_BASE_URL ||
  "https://fq2s41rlfc.execute-api.eu-central-1.amazonaws.com";

const hostBaseUrl =
  process.env.REACT_APP_HOST_BASE_URL || "http://localhost:3000";

export { apiBaseUrl, hostBaseUrl };
